import { createContext, useContext } from 'react'
import type { FilterFieldsStylingContextValue } from './FilterFieldsStylingContext.types'

const defaultContextValue: FilterFieldsStylingContextValue = {}

export const FilterFieldsStylingContext =
  createContext<FilterFieldsStylingContextValue>(defaultContextValue)

export const useFilterFieldsStyling = () => {
  return useContext(FilterFieldsStylingContext)
}
